var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('div',{staticClass:"_container"},[_c('page-header'),_c('div',{staticClass:"_content-section"},[_c('router-view')],1),_c('page-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }